// removed by extract-text-webpack-plugin
module.exports = {"bold":"_1nmqUkuZG5","indented":"_3nb6bny0Wj","borderedTable":"_1kTYMiYoE2 tableList"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/containers/secure/Dashboard/ImportantInformation/Disclaimers/CapOneDisclaimers/CapOneDisclaimers.module.less
// module id = 979
// module chunks = 3